(function (root) {
  'use strict';
  function plan(cart, config) {
    var items = cart.items || [];
    var gifts = items.filter(function (item) { return item.variant_id === config.giftId; });
    var amount = items.reduce(function (sum, item) {
      return sum + (item.variant_id === config.giftId ? 0 : item.final_line_price);
    }, 0);
    var active = Boolean(config.enabled && config.code && config.code.trim());
    var eligible = active && config.identified !== false && !config.returning && config.available && amount >= config.minimum;
    var updates = {};
    gifts.forEach(function (item, index) {
      var managed = item.properties && item.properties._cadeau === 'Bienvenue';
      var quantity = eligible && index === 0 ? 1 : 0;
      if ((active || managed) && item.quantity !== quantity) updates[item.key] = quantity;
    });
    return { eligible: eligible, amount: amount, updates: updates, add: eligible && gifts.length === 0 };
  }
  root.FacGiftRules = { plan: plan };
  if (typeof module !== 'undefined' && module.exports) module.exports = root.FacGiftRules;
})(typeof window === 'undefined' ? globalThis : window);